import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));
